var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tab1/icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4501 2.10561C13.5961 1.50778 12.5191 1.24471 11.4837 1.26899C10.4482 1.29327 9.38375 1.60698 8.55901 2.24843L3.16901 6.44843C2.60552 6.88688 2.134 7.53621 1.80418 8.20842C1.47441 8.88055 1.25 9.64956 1.25 10.36V17.77C1.25 20.5019 3.47347 22.74 6.21 22.74H17.79C20.5254 22.74 22.75 20.5031 22.75 17.78V10.5C22.75 9.74283 22.5017 8.93336 22.1361 8.23297C21.7707 7.53289 21.2484 6.86678 20.6288 6.43474L14.4501 2.10561ZM4.09099 7.63164L9.48046 3.43205C10.0057 3.02363 10.7419 2.7868 11.5188 2.76858C12.2958 2.75036 13.044 2.95241 13.5899 3.33446L19.7696 7.66427L19.7712 7.66533C20.1413 7.9233 20.5195 8.37743 20.8064 8.9271C21.0933 9.47671 21.25 10.0472 21.25 10.5V17.78C21.25 19.677 19.6946 21.24 17.79 21.24H6.21C4.30653 21.24 2.75 19.6781 2.75 17.77V10.36C2.75 9.94051 2.89059 9.39952 3.15082 8.86915C3.4109 8.33907 3.75471 7.89318 4.09099 7.63164ZM12.75 14.99C12.75 14.5758 12.4142 14.24 12 14.24C11.5858 14.24 11.25 14.5758 11.25 14.99V17.99C11.25 18.4042 11.5858 18.74 12 18.74C12.4142 18.74 12.75 18.4042 12.75 17.99V14.99Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ae0ff794977d889829938750de47ba61.svg";
export { ForwardRef as ReactComponent };